module.exports = __webpack_public_path__ + "static/media/school.e6e2a691.png";